import axios from "axios"
import { env } from '../constants'


/* GET HISTORY */
export const history = (token, page = 1, table) => {
    const uri = `${env.startpoint}roulette/history/list?page=${page}&game=RO1${table ? `&table=${encodeURIComponent(table)}` : ""}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const getLast100 = (token, table) => {
    const uri = `${env.startpoint}roulette/history/last100?game=RO1${table ? `&table=${encodeURIComponent(table)}` : ""}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}